import axios from 'axios';
import accessTokenRequest from '@/utils/custom-axios';

const baseApiUrl = `${process.env.VUE_APP_API}/pxmaterials`;

export const EducationService = {
  generatePatientHeaders(patientToken) {
    return {
      Authorization: `Token ${patientToken}`,
    };
  },

  getPxMaterials() {
    return accessTokenRequest.get(`${baseApiUrl}`);
  },

  getSpecificPxMaterial(msgId, token) {
    return axios.get(
      `${baseApiUrl}/${msgId}`,
      {
        headers: this.generatePatientHeaders(token),
      },
    );
  },

  getHTMLOutputPxMaterial(msgId, token) {
    return axios.get(
      `${baseApiUrl}/${msgId}/view`,
      {
        headers: this.generatePatientHeaders(token),
      },
    );
  },

  getAttachedFile(msgId, fileId, token) {
    return axios.get(
      `${baseApiUrl}/${msgId}/files/${fileId}`,
      {
        headers: this.generatePatientHeaders(token),
      },
    );
  },

  sendAnalytics(doctorId, eduMaterialId, token) {
    return axios.post(
      process.env.VUE_APP_ANALYTICS,
      {
        doctorId,
        eduMaterialId,
        token,
        action: 'view',
        type: 6,
        platform: 'web',
      },
    );
  },
}
